'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import YoutubeIframe from '@/app/components/YoutubeIframe';
import { cn } from '@/utils/cn';
import { contentsAPI } from '@/utils/contentsApi';
import { bannerTypes } from '@/constants/types';
import { IMAGE } from '@/constants';
import MarketingBannerSkeleton from '../Skeleton/MarketingBannerSkeleton';
import BannerImageComponent from '../Image/BannerImageComponent';

// swiper slider
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function HomepageMarketingBannerCarousel({ className = '', section }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFirst, setIsFirst] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const contentsData = {
          sectionId: 2,
          contentType: 2,
        };
        const response = await contentsAPI(contentsData);
        setData([...response]);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.warn('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  const handleUserInteraction = (interaction) => {
    setIsFirst(true);
    if (isFirst) {
      setIsPaused(interaction);
    }
  };

  return (
    <div className="home-page-marketing-banner-carousel container 3xl:max-w-[1440px] mx-auto mt-16 mb-24 lg:mt-42 lg:mb-40">
      <div className={cn('relative', className)}>
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          speed={800}
          pagination={{ clickable: true }}
          className="marketing-banner-carousel"
        >
          {loading ? (
            <MarketingBannerSkeleton />
          ) : (
            data?.map((item) => (
              <SwiperSlide key={item?.id}>
                <Link
                  prefetch={false}
                  aria-label="Go to marketing banner item"
                  href={item?.redirect_url?.en?.url ?? '#'}
                >
                  {item?.type === IMAGE ? (
                    <div className="relative rounded-[12px] lg:rounded-[24px] overflow-hidden">
                      <BannerImageComponent
                        desktopSrc={item?.image?.large}
                        mobileSrc={item?.image?.small}
                        type={bannerTypes.homepageMarketingBannerCarousel}
                        alt={item?.title?.en}
                      />
                    </div>
                  ) : (
                    <>
                      {/* experimental */}
                      <div className="relative max-h-[665px] rounded-[24px] overflow-hidden">
                        <YoutubeIframe
                          iframeData={item?.video}
                          className="w-full aspect-[1.02/1] lg:aspect-[1.86/1] object-center object-cover"
                        />
                      </div>
                    </>
                  )}
                </Link>
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>
    </div>
  );
}

export default HomepageMarketingBannerCarousel;
